<template>
  <!-- confirmação genérica no visual do AppSheet: sobe de baixo no celular, botões empilhados -->
  <ModalComponent
    :title="title === null || title === undefined ? 'Confirmar ação' : title"
    id="confirmAlertModal"
    modal-class="app-sheet text-primary"
    backdrop="true"
    @modalClosed="alertClosed"
  >
    <template v-slot:body>
      <p class="text-paragraph mb-0">
        {{ message === null || message === undefined ? "Tem certeza que deseja continuar ?" : message }}
      </p>
    </template>
    <template v-slot:footer>
      <div class="d-flex flex-column gap-3 w-100">
        <button type="button" class="btn-app btn-app-outline" id="confirm-alert-no" @click="cancelAction">Não</button>
        <button type="button" class="btn-app btn-app-secondary" id="confirm-alert-yes" @click="confirmAction">Sim</button>
      </div>
    </template>
  </ModalComponent>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from "vue";
import { EventBus, EventBusNames, type IConfirmationAlert } from "@/utils/EventBus";
import { toggleModal } from "@/utils/Helper";

const MODAL_ID = "confirmAlertModal";
const title = ref<string | null | undefined>(null);
const message = ref<string | null | undefined>(null);
let confirmCallback: () => void = () => {};
let cancelCallback: (() => void) | undefined;

const show = (data: IConfirmationAlert) => {
  confirmCallback = data.confirmCallback;
  cancelCallback = data.cancelCallback;
  title.value = data.title;
  message.value = data.message;
  toggleModal(MODAL_ID);
};
onMounted(() => EventBus.$on(EventBusNames.SHOW_CONFIRMATION_ALERT, show));
onBeforeUnmount(() => EventBus.$off(EventBusNames.SHOW_CONFIRMATION_ALERT, show));

function confirmAction() {
  confirmCallback();
  toggleModal(MODAL_ID);
}
function cancelAction() {
  cancelCallback?.();
  toggleModal(MODAL_ID);
}
// o X já fecha o modal (data-bs-dismiss); o legado chamava cancelAction e disparava o toggle de novo
const alertClosed = () => cancelCallback?.();
</script>
